import { render, staticRenderFns } from "./gameFloor.vue?vue&type=template&id=0383d866&scoped=true&"
import script from "./gameFloor.vue?vue&type=script&lang=js&"
export * from "./gameFloor.vue?vue&type=script&lang=js&"
import style0 from "./gameFloor.vue?vue&type=style&index=0&id=0383d866&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0383d866",
  null
  
)

export default component.exports